<template>
  <div>
    <a @click="getNowServing();">Now Calling:</a>
      <div>{{ from + ' - ' + to }}</div>
  </div>
  <br/>
  <div>
    <label>Input number range to update:</label>
        <input type="number" id="inputFromNumber" v-model="inputFrom" min="0" max="3400" step="50" inputmode="numeric" pattern="[0-9]*"/>
    <span> - </span>
    <input type="number" id="inputToNumber" v-model="inputTo" min="50" max="3500" step="50" inputmode="numeric" pattern="[0-9]*"/>

    <!-- <select id="range" name="range" v-model="optionValue">
      <option v-for="n in numberOfOptions" :key="n" :value=optionsArr[n-1]>{{ optionsArr[n-1] }}</option>
    </select> -->
    <br/>

    <span :class="[msgDisplay]">{{ message }}</span><br/>
    <button type="submit" value="Submit" @click="setNowServing(inputFrom, inputTo)">Submit</button>
  </div>
  
  <br/><br/><br/>

  <div class="mt-3">
    <span>Store Status: {{ statusStr[status] }}</span>
    <br/><br/>
    <select id="range" name="range" v-model="statusInput">
      <option value='0'>{{ statusStr[0] }}</option>
      <option value='1'>{{ statusStr[1] }}</option>
      <option value='2'>{{ statusStr[2] }}</option>
      <option value='3'>{{ statusStr[3] }}</option>
    </select>
    <br/><br/>
    <button type="submit" value="Submit" @click="setStatus( statusInput )">Update Store Status</button>
  </div>
</template>

<script>
import { getNowServing, setNowServing, setStatus } from '../services/nowServing.js'
export default {
  name: 'UpdateDatabase',
  data() {
    return {
      status: 0,
      statusInput: 0,
      statusStr: ['Open', 'Soon', 'Closed', 'Last Chance'],
      from: 0,
      to: 0,
      inputFrom: 0,
      inputTo: 0,
      message: '',
      success: false,
      optionValue: '',
      numberOfOptions: 30,
      rangeInterval: 100
    }
  },
  computed: {
    msgDisplay() {
      return {
        'text-success': this.success,
        'text-red': !this.success
      };
    },
    optionsArr() {
      let arr = [];
      for (let i = 0; i < this.numberOfOptions; i++){
        let fromNum = i * this.rangeInterval + 1;
        let toNum = (i + 1) * this.rangeInterval;
        arr.push(fromNum.toString() + ' - ' + toNum.toString());
      }
      return arr;
    }
  },
  methods: {
    setNowServing(from, to) {
      // if (this.optionValue == '')
      //   return ;

      // let input = this.optionValue.split(' - ');



      setNowServing(from, to).then(response => {
        this.message = response.msg;
        this.success = response.success;
        if(this.success){
          this.getNowServing();
        }
      })
    },
    getNowServing() {
      getNowServing().then(response => {
        this.status = response.status;
        this.statusInput = this.status;
        this.from = response.from;
        this.to = response.to;
        this.inputFrom = this.from;
        this.inputTo = this.to;

        // this.optionValue = this.from + ' - ' + this.to;
      })
    },
    setStatus() {
      setStatus(this.statusInput).then(response => {
        this.status = response.status;
        this.statusInput = this.status;
      })
    }
  },
  created() {
    this.getNowServing();
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getNowServing()
    }, 60000); // in milliseconds
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-red {
  color: #FF0000;
}
</style>
